import React, { useState } from 'react';

export default function ExportPanel({ data, keyword }) {
  const [exporting, setExporting] = useState(null);
  const [error, setError] = useState('');

  if (!data) return null;

  const handleExport = async (format) => {
    setExporting(format);
    setError('');

    try {
      console.log(`📤 Exporting as ${format}...`);
      console.log('📦 Full data:', data);

      const payload = {
        keyword: keyword || data?.keyword || 'analysis',
        data: data  // SEND THE FULL DATA OBJECT
      };

      console.log('📮 Sending payload:', payload);

      const response = await fetch(`https://tube.contentserp.in/api/export/${format}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('authToken')}`
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        throw new Error(`Export failed: ${response.status}`);
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `youtube-analysis-${keyword}.${format === 'word' ? 'docx' : format}`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      console.log(`✅ ${format.toUpperCase()} exported`);
    } catch (err) {
      console.error('❌ Export error:', err);
      setError(err.message);
    } finally {
      setExporting(null);
    }
  };

  return (
    <div className="export-panel" style={{ marginBottom: '20px', padding: '15px', background: '#f9f9f9', borderRadius: '8px' }}>
      <h3>📥 Export Report</h3>
      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
        <button onClick={() => handleExport('pdf')} disabled={exporting !== null} 
                style={{ padding: '10px 20px', background: '#667eea', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
          {exporting === 'pdf' ? '⏳ PDF...' : '📄 Download PDF'}
        </button>
        <button onClick={() => handleExport('word')} disabled={exporting !== null}
                style={{ padding: '10px 20px', background: '#667eea', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
          {exporting === 'word' ? '⏳ Word...' : '📝 Download Word'}
        </button>
        <button onClick={() => handleExport('json')} disabled={exporting !== null}
                style={{ padding: '10px 20px', background: '#667eea', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer' }}>
          {exporting === 'json' ? '⏳ JSON...' : '⚙️ Download JSON'}
        </button>
      </div>
      {error && <div style={{ color: 'red', fontSize: '12px' }}>❌ {error}</div>}
    </div>
  );
}
